export class AdminSubscriptionsBulkPriceChangeDetails {
  public constructor(
    private readonly data: {
      isBulkPriceChangeAvailable: boolean;
    },
  ) {}

  public get isBulkPriceChangeAvailable(): boolean {
    return this.data.isBulkPriceChangeAvailable;
  }
}
